<template>
  <AppLayout> 
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <zestawieniaMenu></zestawieniaMenu>
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Karty ewidencji czasu pracy</h4>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="row col-12">
			<div class="row mb-3">
			  <div class="col-auto d-flex align-items-center me-3">
				<select v-model="selectedDepartament" class="form-select form-sm mb-2"  style="width: 360px;" @change="loadAllDataForUsers">
				  <option value="0">WSZYSTKIE DZIAŁY</option>
				  <option v-for="(department, depId) in departaments" :key="depId" :value="department.id">{{ department.name }}</option>
				  <option value="-1">POZOSTALI PRACOWNICY</option>
 				</select>
			  </div>
			  <div class="col-auto d-flex align-items-center me-3">
				<select v-model="selectedMonth" class="form-select form-sm mb-2"  style="width: 140px;" @change="loadAllDataForUsers">
				  <option v-for="(month, index) in months" :key="index" :value="index + 1">{{ month }}</option>
				</select>
			  </div>
			  <div class="col-auto d-flex align-items-center me-3">
				<select v-model="selectedYear" class="form-select form-sm mb-2" style="width: 140px;" @change="loadAllDataForUsers">
				  <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
				</select>
			  </div>
		  
			  <div class="col-auto d-flex align-items-center me-3 mb-2">
				<a 
				  :href="route('kadry.karty_ewidencji.pdf', { 
					userId: users.map(u => u.userId), 
					year: selectedYear, 
					half: selectedMonth <= 6 ? 1 : 2 
				  })" 
				  target="_blank" 
				  class="btn btn-info me-2"
				>
				  <i class="bi bi-file-earmark-pdf"></i>
				  &nbsp;Pobierz dla okresu {{ selectedMonth <= 6 ? '1-6' : '7-12' }}
				</a>
				
				  <button
    type="button"
    class="btn btn-primary"
    @click="pobierzListeObecnosci"
  >
    <i class="bi bi-people"></i>
    &nbsp;Lista obecności
  </button>


			  </div>
			</div>
		  </div>
		  <div v-for="user in users" :key="user.userId" class="user-card mb-2">
			<h5>{{ user.userName }}</h5>
			  <div class="table-responsive w-100">
			  <table class="table table-bordered table-hover text-center">
				<thead>
				  <tr>
					<th class="bg-gray-100"></th>
					<th v-for="day in getDaysInMonth(selectedMonth)" :key="'head-' + day" class="bg-gray-100">
					  {{ day }}
					</th>
					<th class="bg-gray-100">R</th>
				  </tr>
				</thead>
				<tbody>
				  <!-- wiersz: skróty / dni -->
				  <tr>
					<td class="bg-gray-100 text-start"><strong>{{ monthName2(selectedMonth) }}</strong></td>
					<td v-for="day in getDaysInMonth(selectedMonth)" :key="'day-' + day"
						:class="getCellClassForUser(user, day, selectedMonth, 'days')">
					  {{ getCellValueForUser(user, day, selectedMonth, 'days') }}
					</td>
					<td class="bg-gray-100"><strong>{{ getTotalHoursForUserMonth(user, selectedMonth) }}</strong></td>
				  </tr>

				  <!-- wiersz: godziny -->
				  <tr>
					<td class="bg-gray-100 text-start"><strong>godz.</strong></td>
					<td v-for="day in getDaysInMonth(selectedMonth)" :key="'hours-' + day"
						:class="getCellClassForUser(user, day, selectedMonth, 'hours')">
					  {{ getCellValueForUser(user, day, selectedMonth, 'hours') }}
					</td>
					<td class="bg-gray-100"><strong>{{ getWorkedHoursForUserMonth(user, selectedMonth) }}</strong></td>
				  </tr>
				</tbody>
			  </table>
			</div>
		  </div>
		</div>
	  </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import zestawieniaMenu from "@/Pages/Kadry/parts/zestawieniaMenu.vue";
import axios from 'axios';

export default {
  components: { AppLayout, zestawieniaMenu },
props: {
   departaments: Array,
},
  data() {
    const today = new Date();
    return {
      users: [],
      selectedYear: today.getFullYear(),
      selectedMonth: today.getMonth() + 1,
      months2: ['I','II','III','IV','V','VI','VII','VIII','IX','X','XI','XII'],
      months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
  
      years: Array.from({length: 11}, (_, i) => today.getFullYear() - 10 + i),
      typyUrlopow: [],
      Godziny: {},
selectedDepartament: this.departamentId ?? 1
    };
  },

  methods: {
async pobierzListeObecnosci() {
  try {
    const response = await axios.post(
      route('kadry.lista_obecnosci.pdf'),
      {
        rok: this.selectedYear,
        miesiac: this.selectedMonth,
        departament: this.selectedDepartament
      },
      {
        responseType: 'blob'
      }
    );

    const blob = new Blob([response.data], {
      type: 'application/pdf'
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = `lista_obecnosci_${this.selectedYear}_${this.selectedMonth}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 1000);

  } catch (error) {
    console.error('Błąd generowania listy obecności:', error);
  }
},
  isBeforeContractStart(user, day, month) {
  if (!user.umowa_od) return false; // brak daty rozpoczęcia → pracuje od początku miesiąca
  const contractStart = new Date(user.umowa_od + 'T00:00:00'); // początek dnia
  const currentDate = new Date(this.selectedYear, month - 1, day);
  return currentDate < contractStart;
},

isAfterContractEnd(user, day, month) {
  if (!user.umowa_do) return false; // brak daty końca → pracuje nadal
  const contractEnd = new Date(user.umowa_do + 'T23:59:59'); // koniec dnia umowy
  const currentDate = new Date(this.selectedYear, month - 1, day);
  return currentDate > contractEnd;
},
    // Miesiące
    monthName2(month) { return this.months2[month-1]; },
     monthName(month) { return this.months[month-1]; },
   getDaysInMonth(month) { return Array.from({ length: new Date(this.selectedYear, month, 0).getDate() }, (_, i) => i + 1); },

    // Data i weekend
    getDateString(day, month) { return `${this.selectedYear}-${String(month).padStart(2,'0')}-${String(day).padStart(2,'0')}`; },
    isWeekend(month, day) { const d = new Date(this.selectedYear, month-1, day); return d.getDay() === 0 || d.getDay() === 6; },

    // Święta
    getPolishHolidays(year) {
      const format = d => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
      const fixed = [`${year}-01-01`,`${year}-01-06`,`${year}-05-01`,`${year}-05-03`,`${year}-08-15`,`${year}-11-01`,`${year}-11-11`,`${year}-12-24`,`${year}-12-25`,`${year}-12-26`];
      const easter = this.getEasterDate(year);
      fixed.push(format(easter), format(new Date(easter.getTime() + 86400000)), format(new Date(easter.getTime() + 60*86400000)));
      return fixed;
    },
    isHoliday(dateStr) { const year = parseInt(dateStr.substr(0,4)); return this.getPolishHolidays(year).includes(dateStr); },

    // Kolory i wartości
getCellClassForUser(user, day, month, type) {
  const key = this.getDateString(day, month);
  const absence = user.absences[key];

  if(this.isWeekend(month, day) || this.isHoliday(key)) return 'bg-Lightblue text-white';
  if(!absence) return 'bg-white text-black';

  // najpierw skrót z urlopu, jeśli brak → z typy urlopu
  const skrot = absence?.skrot ?? (this.typyUrlopow.find(t => t.id === absence.raw_typ_urlopu)?.skrot ?? '');

  if(['Śrh','Ch','ChO','Nn','N','L4'].includes(skrot)) return 'text-red';
  if(['D','S'].includes(skrot)) return 'text-black';
  if(['K','Sz','Np','Wpp','Us'].includes(skrot)) return 'text-blue';
  return 'text-green';
},

getCellValueForUser(user, day, month, type) {
  // jeśli przed rozpoczęciem lub po zakończeniu umowy → nic nie wyświetlamy
  if (this.isBeforeContractStart(user, day, month) || this.isAfterContractEnd(user, day, month)) return '';

  const key = this.getDateString(day, month);
  
  if (this.isWeekend(month, day) || this.isHoliday(key)) return '';
  
  const absence = user.absences[key];
  const etatHours = user.liczba_godzin ?? 8;

  if (type === 'days') {
    if (absence) {
      const skrot = absence?.skrot ?? (this.typyUrlopow.find(t => t.id === absence.raw_typ_urlopu)?.skrot ?? '');
      return skrot || etatHours;
    }
    return etatHours;
  }

if (type === 'hours') {
    if (!this.isDayUpToToday(day, month)) return '';
    if (absence) {
      const skrot = absence?.skrot ?? (this.typyUrlopow.find(t => t.id === absence.raw_typ_urlopu)?.skrot ?? '');
      if (['Śrh','Ch','ChO','Nn','N','L4','Ub'].includes(skrot)) return -etatHours;
      if (['Uw','Np','Wpp','Uo','D','UWW','Uż'].includes(skrot)) return etatHours;
      return etatHours;
    }

    const key = this.getDateString(day, month);
    let hours = this.Godziny?.[user.userId]?.[key] ?? null;

    if (!hours) return ''; // <<< tu dodajemy: jeśli brak godzin, nic nie pokazujemy

    const changeGodziny = (hours) => {
      if (!hours || typeof hours !== 'string' || !hours.includes('-')) return ''; // też zwracamy pusty jeśli niepoprawny format
      const [startStr] = hours.split('-');
      const [h, m = 0] = startStr.split(':').map(Number);
      const startFloat = h + m / 60;
      const endFloat = startFloat + etatHours;
      const startHour = Math.floor(startFloat);
      const startMinutes = Math.round((startFloat - startHour) * 60);
      const endHour = Math.floor(endFloat);
      const endMinutes = Math.round((endFloat - endHour) * 60);
      const formatTime = (hour, minutes) => minutes === 0 ? `${hour}` : `${hour}:${minutes.toString().padStart(2,'0')}`;
      return `${formatTime(startHour, startMinutes)}-${formatTime(endHour, endMinutes)}`;
    };

    return changeGodziny(hours);
}

},

getTotalHoursForUserMonth(user, month) {
  return this.getDaysInMonth(month).reduce((sum, day) => {
    if(this.isWeekend(month, day) || this.isHoliday(this.getDateString(day, month))) return sum;
    return sum + (user.liczba_godzin ?? 8);
  },0);
},

getWorkedHoursForUserMonth(user, month) {
  return this.getDaysInMonth(month).reduce((sum, day) => {
    const key = this.getDateString(day, month);

    // Przed rozpoczęciem lub po zakończeniu umowy → pomijamy
    if (this.isBeforeContractStart(user, day, month) || this.isAfterContractEnd(user, day, month)) return sum;

    // Tylko dni do dziś
    if (!this.isDayUpToToday(day, month)) return sum;

    // Weekend lub święto → pomijamy
    if (this.isWeekend(month, day) || this.isHoliday(key)) return sum;

    const etatHours = user.liczba_godzin ?? 8;
    const absence = user.absences[key];

    // Urlop → uwzględniamy typ
    if (absence) {
      const typeObj = this.typyUrlopow.find(t => t.id === absence.raw_typ_urlopu);
      const skrot = typeObj?.skrot ?? '';
      if (['Śrh','Ch','ChO','Nn','N','L4','Ub'].includes(skrot)) return sum; // 0 godzin
      if (['Uw','Np','Wpp','Uo','UWW','Uż'].includes(skrot)) return sum + etatHours;   // pełne godziny
      return sum + etatHours; // domyślnie pełne godziny
    }

    // Faktyczne godziny z odbitek
    const hoursStr = this.Godziny?.[user.userId]?.[key] ?? null;
    if (!hoursStr) return sum; // brak godzin → 0

    const [startStr, endStr] = hoursStr.split('-');
    const [startH, startM = 0] = startStr.split(':').map(Number);
    const [endH, endM = 0] = endStr.split(':').map(Number);

    const hoursWorked = (endH + endM/60) - (startH + startM/60);
    return sum + hoursWorked;

  }, 0);
},



    getEasterDate(year) {
      const f = Math.floor;
      const G = year % 19;
      const C = f(year/100);
      const H = (C - f(C/4) - f((8*C+13)/25) + 19*G + 15) % 30;
      const I = H - f(H/28)*(1 - f(29/(H+1))*f((21-G)/11));
      const J = (year + f(year/4) + I + 2 - C + f(C/4)) % 7;
      const L = I - J;
      const month = 3 + f((L+40)/44);
      const day = L + 28 - 31*f(month/4);
      return new Date(year, month-1, day);
    },

    // Ładowanie danych
    async loadAllDataForUsers() {
console.log('this.selectedDepartament',this.selectedDepartament);

      try {
        const response = await axios.get(route('kadry.karty_ewidencji.kartagetallinfo'), { params: { departament: this.selectedDepartament, rok: this.selectedYear, miesiac: this.selectedMonth } });
		this.users = response.data.users.map(u => {
		const absences = {};
          (u.urlopy ?? []).forEach(urlop => {
            let start = new Date(urlop.start);
            let end = new Date(urlop.end);
            while(start <= end){
              const key = `${start.getFullYear()}-${String(start.getMonth()+1).padStart(2,'0')}-${String(start.getDate()).padStart(2,'0')}`;
              absences[key] = urlop;
              start.setDate(start.getDate() + 1);
            }
          });
          return { ...u, urlopy: u.urlopy ?? [], absences };
        });

        this.typyUrlopow = response.data.typyUrlopow ?? [];

        const userIds = this.users.map(u => u.userId);
        const hoursResponse = await axios.get(route('kadry.karta_ewidencji.workHoursForMonth'), {
          params: { rok: this.selectedYear, miesiac: this.selectedMonth, user_ids: userIds }
        });
        this.Godziny = hoursResponse.data.Godziny || {};
        this.users = this.users.map(u => ({ ...u, godziny: this.Godziny[u.userId] || u.liczba_godzin || '6-14' }));
      } catch (error) { console.error("Błąd ładowania danych:", error); }
    },

getHalf() {
  return this.selectedMonth <= 6 ? 1 : 2;
},


  getFilledPdfUrl() {
  return route('kadry.karty_ewidencji.pdf', { 
    userId: this.users.map(u => u.userId), // cała lista
    year: this.selectedYear, 
    half: this.getHalf()
  });
},

getEmptyPdfUrl() {
  return route('kadry.puste.karty_ewidencji.pdf', { 
    userId: this.users.map(u => u.userId),
    year: this.selectedYear, 
    half: this.getHalf()
  });
},
isDayUpToToday(day, month) {
  const today = new Date();
  const date = new Date(this.selectedYear, month - 1, day);

  // Rok/miesiąc wcześniejszy niż obecny → zawsze true
  if (this.selectedYear < today.getFullYear()) return true;
  if (this.selectedYear === today.getFullYear() && month < today.getMonth() + 1) return true;

  // Rok/miesiąc późniejszy niż obecny → zawsze false
  if (this.selectedYear > today.getFullYear()) return false;
  if (this.selectedYear === today.getFullYear() && month > today.getMonth() + 1) return false;

  // Jeśli to ten sam miesiąc/rok → sprawdzamy dzień
  return date <= today;
}

  },

  mounted() { this.loadAllDataForUsers(); }
};
</script>

<style scoped>
table th, table td { min-width: 32px; height: 32px; text-align: center; }
.bg-Lightblue { background-color: #5fb2d8; }
.bg-gray-100 { background-color: #f5f5f5; color: black; }
.bg-gray-50 { background-color: #ddd9c3; color: black; }
.text-white { color: white; }
.text-black { color: black; }
.text-red { color: red; }
.text-green { color: green; }
.text-blue { color: blue; }
</style>
